import { SliderOwnProps, SxProps, Theme } from "@mui/material";
import { HTMLInputTypeAttribute, KeyboardEventHandler } from "react";
import {
  Control,
  FieldValues,
  RegisterOptions,
  UseFormResetField,
  UseFormWatch,
} from "react-hook-form";

export const textFieldHeight = 40;
export const textFieldHeightSmall = 36;
export const textFieldHeightLarge = 56;

export type TypeSizeTextField = "small" | "medium" | "large";
export type VariantSearchTextField = "text-image" | "text-icon";

export type inputTypes =
  | "number"
  | "text"
  | "color-picker"
  | "number-slider"
  | "select"
  | "slider"
  | "border"
  | "shadow"
  | "padding"
  | "more"
  | "radio"
  | "checkbox"
  | "segment"
  | "switch";

export type switchType = "color" | "flat" | "neon" | "border";

export interface IMenu {
  id: string;
  value: any;
  label: any;
  description?: string;
  icon?: any;
  disabled?: boolean;
}

export interface IInput {
  name: string;
  control: Control<any, any>;
  watch?: UseFormWatch<any>;
  resetField?: UseFormResetField<any>;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, any>,
        "disabled" | "valueAsNumber" | "valueAsDate" | "setValueAs"
      >
    | any;
  defaultValue?: any;
  inputLabel?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: TypeSizeTextField;
  sx?: SxProps<Theme>;
  textField?: {
    startAdornment?: JSX.Element;
    endAdornment?: JSX.Element;
    placeholder?: string;
    onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
    attributeType?: HTMLInputTypeAttribute;
    decimalScale?: number;
    autoFocus?: boolean;
    readOnly?: boolean;
    multiline?: boolean;
    multilineRow?: number;
    minRows?: number;
    checkIconReverse?: boolean;
    onBlur?: any;
  };
  slider?: {
    min?: number;
    max?: number;
    step?: number;
    marks?: any;
    start?: React.ReactNode;
    end?: React.ReactNode;
    valueLabelDisplay?: SliderOwnProps["valueLabelDisplay"];
  };
  radio?: {
    row?: boolean;
  };
  picture?: string;
  onChange?: (v: any) => void;
  menus?: IMenu[];
  switchProps?: {
    type: switchType;
  };
  select?: {
    clearSelect?: boolean;
  };
}
